import React from 'react';
import './commandSection.scss';
import {commandDataList} from "../../../../components/utils/dataLists";

const CommandSection = () => {

	return (
		<div className="commandSection">
			<div className="commandSection__background"></div>
			<div className="commandSection__content">
				{
					commandDataList &&
					commandDataList.length > 0 &&
					commandDataList.map((item: any, index: number) => (
						<div
						key={`${item.name} - ${index}`}
							className="commandSection__content_item"
						>
							<div className="commandSection__content_item_front">
								{/*<div className="commandSection__content_item_front_avatar"></div>*/}
								<div className="commandSection__content_item_front_info">
									<span>{item.name}</span>
									<p>{item.post}</p>
								</div>
							</div>
						</div>
					))
				}
			</div>
		</div>
	);
};

export default CommandSection;